import { FC } from "react";
import { clsxMerge } from "shared/lib/helpers/styles";

import { PropsWithClassNameI } from "shared/lib/interfaces/ui";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "shared/ui/shadcn/select";

const generateTimeOptions = () => {
  const options = [];
  for (let hour = 7; hour <= 12; hour++) {
    for (let minute = 0; minute < 60; minute += 15) {
      const period = hour === 12 ? "PM" : "AM";
      const timeString = `${hour}:${minute
        .toString()
        .padStart(2, "0")} ${period}`;
      options.push({
        value: timeString,
        label: timeString,
      });
      if (hour === 12 && minute === 0) break; // Stop at 12:00 PM
    }
    if (hour === 12) break; // Ensure we don't continue past 12:00 PM
  }

  return options;
};

const timeOptions = generateTimeOptions();

/**
 * Select the time to send the follow-up email
 *
 * @param value{string} - The time to send the follow-up email (e.g. "12:00 PM")
 * @param onChange{function} - The function to call when the value changes
 * @returns
 */
export const SelectTime: FC<
  PropsWithClassNameI & { value: string; onChange?: (value: string) => void }
> = ({ className, value, onChange }) => {
  const handleTimeChange = (value: string) => {
    onChange?.(value);
  };

  return (
    <Select value={value} onValueChange={handleTimeChange}>
      <SelectTrigger
        className={clsxMerge("w-[110px] focus:ring-transparent", className)}
      >
        <SelectValue placeholder="Select time" />
      </SelectTrigger>
      <SelectContent>
        {timeOptions.map((option) => (
          <SelectItem key={option.value} value={option.value}>
            {option.label}
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
};
